import {useEffect, useState} from 'react';

/**
 * Checks if the currently focused element is an editable element
 * (input, textarea, or contenteditable).
 * Useful for preventing keyboard shortcuts from triggering when user is typing.
 */
export const isEditableElementFocused = (): boolean => {
  const activeElement = document.activeElement;
  return (
    activeElement instanceof HTMLInputElement ||
    activeElement instanceof HTMLTextAreaElement ||
    activeElement?.hasAttribute('contenteditable') === true
  );
};

export function useViewportWidth() {
  const [width, setWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 0,
  );

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return width;
}
